import { Link } from 'react-router-dom';
import { SOCIAL_LINKS } from '../../social-links';
import { scrollTop } from '../../utils/utils';
import Guarantee from '../guarantee/guarantee.component';
import './footer.styles.scss';

const COLUMNS = [
  {
    title: 'Boutique',
    links: [
      { label: 'Toute la boutique', to: '/shop' },
      { label: 'Fleurs', to: '/shop/fleurs' },
      { label: 'Hasch', to: '/shop/hasch' }
    ]
  },
  {
    title: 'Informations',
    links: [
      { label: 'Livraison', to: '/delivery-infos' },
      { label: 'Contact', to: '/contact' },
      { label: 'CGV', to: '/CGV' },
      { label: 'Mentions légales', to: '/mentions-legales' }
    ]
  }
];

const Footer = () => (
  <footer className="site-footer">
    <Guarantee />

    <div className="footer-main">
      <div className="footer-brand">
        <p className="footer-brand-name">Lacana</p>
        <p className="footer-brand-baseline">CBD Shop — Étampes</p>
        <p className="footer-brand-text">
          Fleurs et résines sélectionnées directement chez les producteurs,
          testées en laboratoire.
        </p>
      </div>

      {COLUMNS.map((column) => (
        <nav
          className="footer-column"
          key={column.title}
          aria-label={column.title}
        >
          <p className="footer-column-title">{column.title}</p>
          <ul>
            {column.links.map((link) => (
              <li key={link.to}>
                <Link to={link.to} onClick={scrollTop}>
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      ))}

      <div className="footer-column">
        <p className="footer-column-title">Nous suivre</p>
        <div className="footer-social">
          {SOCIAL_LINKS.map(({ label, href, Icon }) => (
            <a
              href={href}
              key={label}
              target="_blank"
              rel="noreferrer"
              aria-label={label}
            >
              <Icon />
            </a>
          ))}
        </div>
        <a className="footer-phone" href="tel:+33979261053">
          09 79 26 10 53
        </a>
      </div>
    </div>

    {/* La bande porte le fond sur toute la largeur, son enfant recentre le contenu. */}
    <div className="footer-bottom">
      <div className="footer-bottom-inner">
        {/* Année calculée : un millésime écrit en dur vieillit sans prévenir. */}
        <p>
          © {new Date().getFullYear()} Lacana CBD Shop — Tous droits réservés.
        </p>
        <p className="footer-legal">
          Produits contenant moins de 0,3 % de THC, conformément à la
          législation française en vigueur.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
